import { createSlice } from "@reduxjs/toolkit";

const initialOrderReturnState = {
  entities: [],
  orderId: null,
  customer: null,
  copyOrderEntity: undefined,
  products: [],
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  completed: false,
  skipTobaccoEligibilityTest: false,
  currentOrder: {},
  card: {
    requiresAction: false,
    paymentIntentClientSecret: "",
  },
  message: {
    error: null,
    success: null,
  },
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const orderReturnSlice = createSlice({
  name: "orderReturn",
  initialState: initialOrderReturnState,
  reducers: {
    catchError: (state, action) => {
      let error =
        action.payload.error.response && action.payload.error.response.data ? action.payload.error.response.data.errors : action.payload.error.message;
      if (error.constructor.name === "Object") {
        let temp = [];
        for (let [k, v] of Object.entries(error)) {
          temp.push(`${k}->${v}`);
        }
        error = temp;
      }
      state.message.error = error;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // createOrder
    orderCreated: (state, action) => {
      const { message, entity } = action.payload;
      state.entities = [];
      state.actionsLoading = false;
      state.currentOrder = entity;
      state.copyOrderEntity = null;
      state.completed = true;
      state.message.success = message;
    },

    orderRequiresAction: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { entity } = action.payload;
      state.card.requiresAction = entity.requires_action;
      state.card.paymentIntentClientSecret = entity.payment_intent_client_secret;
    },

    //change tobacco sale eligibility test
    changeTobaccoSaleEligibilityTest: (state, action) => {
      state.skipTobaccoEligibilityTest = action.payload.skipTobaccoEligibilityTest;
    },
    //deselect customer selected for order
    removeCustomer: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.customer = null;
    },

    // updateOrder
    orderUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map((entity) => {
        if (entity.id === action.payload.order.id) {
          return action.payload.order;
        }
        return entity;
      });
    },

    // ordersUpdateState
    ordersStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map((entity) => {
        if (ids.findIndex((id) => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    },
    removeUnmountDate: (state, action) => {
      state.actionsLoading = false;
      state.copyOrderEntity = null;
    },

    //copy order from order history
    copyOrder: (state, action) => {
      state.actionsLoading = false;
      const { entity } = action.payload;
      state.copyOrderEntity = entity;
      state.customer = entity.customer;
    },

    //change complete status
    changeCompleteStatus: (state, action) => {
      const { status } = action.payload;
      state.completed = status;
    },

    //update message
    updateMessage: (state, action) => {
      const { type, message } = action.payload;
      switch (type) {
        case "error":
          state.message.error = message;
          break;
        case "success":
          state.message.success = message;
          break;
      }
    },
  },
});
